import { useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import { useSessionStorage } from "usehooks-ts"

import { presetStorageKey } from "~/components/planning/presetView"
import {
  assortmentTableId,
  assortmentPresetGroupId,
} from "~/components/demand-2/shared/useOpenInPreorders"
import { useTableSearch } from "~/hooks/useTableSearch"

/** Opens Assortment > New narrowed to one variant, where its match is set. */
export const useOpenInAssortment = (collectionId: number, kind: "fashion" | "noos") => {
  const navigate = useNavigate()
  const { setSearchText, setSearchBy } = useTableSearch(
    assortmentTableId("new", kind, collectionId),
  )
  const [, setPresetId] = useSessionStorage<string | null>(
    presetStorageKey(assortmentPresetGroupId(collectionId)),
    null,
  )
  return useCallback(
    (variantId: string) => {
      setSearchBy("variant")
      setSearchText(`"${variantId}"`)
      setPresetId("new")
      void navigate({
        to:
          kind === "noos"
            ? "/demand/noos/$collectionId/variants"
            : "/demand/fashion/$collectionId/variants",
        params: { collectionId: String(collectionId) },
        search: (prev: Record<string, unknown>) => ({ ...prev, strategy: undefined }),
      })
    },
    [setSearchBy, setSearchText, setPresetId, navigate, collectionId, kind],
  )
}
